import { Action as ReduxAction } from 'redux';

import { ReactModalService } from '~commonInfra/dialogs/ReactModalService';
import { Messages } from '~src/codegen/Localize';
import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';
import { IContentInfo } from '~src/spacesPlatform/models/IContentInfo';

import { RelayPlanDialogOpts } from '../components/RelayPlanDialog';
import { ContentRelayUtils } from '../utils/ContentRelayUtils';
import { isItemSupportedForRelay } from '../utils/supportedContentTypes';

/**
 * Explore → Actions → "Add to Relay Plan" (shown directly below "Add to Collections", gated by the
 * content-mobility flag + capability). Opens {@link RelayPlanDialog} with the selected items, where
 * the user creates a new Content Relay plan or adds the selection to an existing one.
 *
 * Unlike the saga-backed dialog actions in this menu, this opens the dialog imperatively via
 * ReactModalService (new code avoids Redux/Saga) and returns a no-op action — the menu dispatches
 * whatever createReduxAction returns, so it must be a valid, side-effect-free action, not undefined.
 */
export const AddToContentRelayPlanEntityAction: IEntityAction<IContentInfo, {}> = {
  name: EntityActionNames.AddToContentRelayPlan,
  translateName: Messages.addToRelayPlan,
  isVisible: (targetItems: IContentInfo[]) =>
    ContentRelayUtils.isContentRelayEnabled() && targetItems.length > 0,
  isClickable: (_availableActions: {}, targetItems: IContentInfo[]) =>
    targetItems.length > 0 && targetItems.every(isItemSupportedForRelay),
  createReduxAction: (targetItems: IContentInfo[]): ReduxAction => {
    ReactModalService.openCustom(RelayPlanDialogOpts(targetItems));
    return { type: 'contentRelay/openPlanDialogRequested' };
  },
};
